export const FIGURE_SIZE = 17;
export const SYMBOL_SIZE = 5.4;
export const PADDING_ELEMENT_COMBINED = 28;
export const FIGURE_SIZE_COMBINED = 22;
export const SYMBOL_SIZE_COMBINED = 6.0;
export const PADDING_ELEMENT = 14;
export const CIRCLE_RADIUS = 5;
